import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;

  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 16px;
`

export const Tabs = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-200);
`

export const Tab = styled.button<{ $active: boolean }>`
  display: flex;

  justify-content: center;
  align-items: center;
  gap: var(--space-300);

  border-radius: var(--radius-brand);
  padding: var(--space-200) var(--space-350);

  color: var(--text-secondary);
  text-align: center;
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-400);
  letter-spacing: var(--font-letter-spacing-normal);

  &:hover {
    background: var(--bg-transparent);
    color: var(--text-primary);
  }

  ${({ $active }) =>
    $active &&
    css`
      background: var(--bg-transparent);
      color: var(--text-primary);
    `}
`
